import { __rest } from '../../../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useMemo } from 'react';
import cns from '../../../../node_modules/classnames/index.js';
import Button from '../../Button/Button.js';
import { NOOP } from '../../../../utils/const.js';
import { InputStatesEnum, createBadgeStatus } from '../common.js';
import FormFieldFrameLegend from './FormFieldFrameLegend.js';
import FormFieldFrameLabel from './FormFieldFrameLabel.js';
import EllipsisText from '../../../EllipsisText/EllipsisText.js';
import Tooltip from '../../Tooltip/Tooltip.js';
import { EmphasisLM, InfoState } from '../../../types.js';

function getHelperTextClassname(componentHeight) {
    return cns('v2-form-field-frame__message', 'v2-form-field-frame__message--helper', {
        'v2-form-field-frame__message--helper-height-placeholder': componentHeight === 'with-helper-text',
    });
}
function getTooltipType(state) {
    if (state === InputStatesEnum.alarm)
        return InfoState.alarm;
    if (state === InputStatesEnum.warning)
        return InfoState.warning;
    if (state === InputStatesEnum.success)
        return InfoState.success;
    return undefined;
}
function FormFieldFrameComp({ className, onClick, children, title, titleIcon, state, stateMessage, helperText, icon, disabled, readOnly, action, onActionClick = NOOP, rootProps, size, componentHeight, footer, emphasis, }) {
    const badgeState = useMemo(() => createBadgeStatus(state, emphasis), [emphasis, state]);
    // se faccio click "in giro" do il focus all'input
    const handleActionClick = (evt) => {
        // evito la propagazione che darebbe il focus all'input
        evt.stopPropagation();
        onActionClick(evt);
    };
    const existAction = !readOnly && action;
    return (jsxs("div", Object.assign({}, rootProps, { className: cns('v2-form-field-frame', `v2-form-field-frame--${emphasis.toLowerCase()}`, className), style: size, children: [jsx(FormFieldFrameLabel, { emphasis: emphasis, title: title, titleIcon: titleIcon }), jsxs("fieldset", { onClick: onClick, className: "v2-form-field-frame__group", children: [jsx(FormFieldFrameLegend, { emphasis: emphasis, title: title, titleIcon: titleIcon }), jsxs("section", { className: cns('v2-form-field-frame__main', {
                            // la action occupa tutto lo spazio a sx per essere cliccabile, se non c'è devo aggiungere dei padding
                            'v2-form-field-frame__main--no-action': !existAction,
                        }), children: [icon && jsx("div", { className: "v2-form-field-frame__icon", children: icon }), children, badgeState && jsx("div", { className: "v2-form-field-frame__state-badge", children: badgeState }), existAction && jsx("div", { className: "v2-form-field-frame__state-separator" }), existAction && (jsx(Button, { tabIndex: -1, disabled: disabled, emphasis: Button.Emphasis.LOW, className: "v2-form-field-frame__action", onClick: handleActionClick, children: action }))] }), footer] }), emphasis !== EmphasisLM.LOW && !readOnly && stateMessage
                && (jsx(EllipsisText, { top: false, className: "v2-form-field-frame__message v2-form-field-frame__message--state", children: stateMessage })), emphasis !== EmphasisLM.LOW && !readOnly && helperText && !stateMessage
                && (jsx(EllipsisText, { top: false, className: getHelperTextClassname(componentHeight), children: helperText }))] })));
}
/**
 * Costruisce un bordo attorno ad un componente di input con titolo.
*/
// eslint-disable-next-line react/require-default-props
function FormFieldFrame(props) {
    const { tooltipProps, className } = props, compProps = __rest(props, ["tooltipProps", "className"]);
    const { stateMessage, state, emphasis } = compProps;
    if (emphasis === EmphasisLM.LOW) {
        return (jsx("div", { className: cns('v2-form-field-frame-tooltip', className), children: jsx(Tooltip, Object.assign({}, tooltipProps, { type: getTooltipType(state), content: stateMessage, children: jsx(FormFieldFrameComp, Object.assign({}, compProps)) })) }));
    }
    return jsx(FormFieldFrameComp, Object.assign({ className: className }, compProps));
}
FormFieldFrame.defaultProps = {
    action: undefined,
    className: undefined,
    onActionClick: NOOP,
    onClick: NOOP,
    readOnly: false,
    disabled: false,
    state: undefined,
    stateMessage: undefined,
    title: undefined,
    titleIcon: undefined,
    icon: undefined,
    rootProps: {},
    size: {},
    helperText: undefined,
    componentHeight: 'minimal',
    footer: null,
    tooltipProps: {},
};

export { FormFieldFrame as default };
